import { instance2, errorHandler } from "./http";

const deviceList = () => {
  return instance2.get('/thingsboard/').then((response) => { return response.data; })
                   .catch((error) => errorHandler(error))
}

const AssignDevice = (data) => {
  const { deviceId, field } = data
  return instance2.post(`/thingsboard/devices/${deviceId}/assign-field`,field).then((response) => { return response.data; })
                   .catch((error) => errorHandler(error))
}

const UpdateCredentials = (data) => {
  const { deviceId, credentials } = data
  return instance2.post(`/thingsboard/devices/${deviceId}/wifi`,credentials).then((response) => { return response.data; })
                   .catch((error) => errorHandler(error))
}


export const deviceService = {
    deviceList,
    AssignDevice,
    UpdateCredentials
}